/* @flow */
import React from 'react';
import type { Node } from 'react';
import type { TApartSelectionInfo } from '../../../../types/apart';
import { RelevanceDescription, RelevanceHeader, RelevanceTitle, RelevanceWrapper } from './styles';
import WishesList from '../../../WishesList';

type TProps = {
	selectionInfo: TApartSelectionInfo,
};

const Relevance = ({ selectionInfo }: TProps): Node => {
	const { relevancePercent, wishesTexts } = selectionInfo;
	return (
		<RelevanceWrapper>
			<RelevanceHeader>
				<RelevanceTitle>Квартира подходит вам на {relevancePercent}%</RelevanceTitle>
			</RelevanceHeader>
			{wishesTexts?.length > 0 && (
				<RelevanceDescription>
					<WishesList wishes={wishesTexts} />
				</RelevanceDescription>
			)}
		</RelevanceWrapper>
	);
};

export default Relevance;
